import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { CropImageModal } from './CropImageModal';
export const useCropImageModal = ({ onSuccess, skipFileTypes = ['image/svg+xml', 'image/gif'], options, }) => {
    const [cropFile, setCropFile] = useState(null);
    const onSelectFile = (file) => {
        // do not crop svg and gif files
        if (skipFileTypes === null || skipFileTypes === void 0 ? void 0 : skipFileTypes.includes(file === null || file === void 0 ? void 0 : file.type)) {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({ croppedImage: file, zoom: 1, crop: { x: 0, y: 0 } });
            return;
        }
        setCropFile(file);
    };
    const onCrop = (cropResult) => {
        setCropFile(null);
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(cropResult);
    };
    const reset = () => {
        setCropFile(null);
    };
    const children = (_jsx(_Fragment, { children: cropFile && (_jsx(CropImageModal, { open: true, close: reset, initialImage: cropFile, onSubmit: onCrop, options: options }, void 0)) }, void 0));
    return {
        onSelectFile,
        children,
    };
};
//# sourceMappingURL=useCropImageModal.js.map